var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 296,
    viewBox: "0 0 240 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.98 146.223C133.97 152.461 139.511 159.307 143.398 164.094C147.721 151.097 141.948 132.937 135.508 119.36C133.97 127.802 131.823 136.737 128.98 146.223Z",
    fill: "#E4FBCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5776 98.1248C92.1664 104.275 86.4224 115.763 90.7449 133.72C94.6323 133.401 100.144 132.966 105.134 132.502C102.291 119.737 100.144 108.336 98.5776 98.1248Z",
    fill: "#A6EE68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.386 162.092C76.5296 24.4102 106.033 12.7192 117.173 8.01953C128.312 25.5996 157.787 71.3195 121.901 167.575L112.386 162.092Z",
    fill: "url(#paint0_linear_1300_10058)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.946 154.172C87.0894 16.5195 116.564 4.79948 127.732 0.0998535C138.872 17.6799 168.347 63.3998 132.461 159.655L122.946 154.172Z",
    fill: "url(#paint1_linear_1300_10058)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M121.901 167.575C157.786 71.3195 128.312 25.5996 117.172 8.01953V164.848L121.901 167.575Z",
    fill: "url(#paint2_linear_1300_10058)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.848 56.4954C127.848 64.8793 122.917 68.8246 116.825 65.3144C110.732 61.8042 105.801 52.1439 105.801 43.76C105.801 35.3761 110.732 31.4307 116.825 34.9409C122.917 38.4511 127.848 48.1115 127.848 56.4954Z",
    fill: "#6F00FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.671 198.732C123.147 194.612 121.929 189.39 120.856 184.807C119.608 179.527 118.564 175.03 115.953 173.899C112.965 172.593 111.63 175.901 109.745 180.484C108.642 183.182 107.337 186.373 105.422 189.303C103.362 187.128 101.187 185.329 98.895 184.023C89.2926 178.483 81.2858 183.269 79.4002 194.699C78.0947 193.713 76.7893 192.813 75.4548 192.03C60.0505 183.153 47.5762 193.22 47.5762 214.571C47.5762 235.893 60.0505 260.378 75.4258 269.255C90.366 277.871 102.579 268.617 103.275 248.571C106.089 253.793 109.832 258.173 113.98 260.552C115.054 261.161 116.098 261.625 117.084 261.915C123.06 275.057 131.966 286.371 141.917 292.115C159.903 302.5 174.495 290.78 174.524 265.948C174.524 241.115 159.932 212.54 141.946 202.155C135.999 198.732 130.458 197.687 125.671 198.732Z",
    fill: "url(#paint3_linear_1300_10058)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.875 132.56L205.916 150.488V154.085L174.875 136.157V132.56Z",
    fill: "#6F00FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M162.631 103.413L205.18 127.974V219.6L162.631 195.039V103.413Z",
    fill: "url(#paint4_linear_1300_10058)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.086 134.182L155.514 109.621V201.247L198.063 225.808L198.086 134.182ZM169.386 123.493L183.6 131.68V135.319L169.386 127.246V123.493Z",
    fill: "url(#paint5_linear_1300_10058)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M159.631 167.589L193.812 187.306V190.399L159.631 170.682V167.589Z",
    fill: "#6F00FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M162.019 175.026L191.401 191.991V195.084L161.996 178.119L162.019 175.026Z",
    fill: "#6F00FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.306 159.903C186.306 152.648 182.054 144.302 176.823 141.277C171.593 138.252 167.34 141.686 167.34 148.941C167.34 156.196 171.593 164.542 176.823 167.566C182.054 170.591 186.306 167.157 186.306 159.903Z",
    fill: "#C9F6A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.915 45.9358L8.38477 0.62207L8.41378 41.5552L80.0106 82.8655L86.944 93.1351L86.915 45.9358Z",
    fill: "url(#paint6_linear_1300_10058)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5776V5.4668L29.6483 22.5827V33.6936L0 16.5776Z",
    fill: "#A6EE68"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.7225 44.253L49.5195 34.3315V37.9288L66.7225 47.8502V44.253Z",
    fill: "#6F00FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.7229 51.4477L33.5645 32.301V35.8983L66.7229 55.0449V51.4477Z",
    fill: "#6F00FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.7238 58.6421L26.5449 35.4341V39.0313L66.7238 62.2394V58.6421Z",
    fill: "#6F00FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.959 50.4322C70.959 53.7974 72.9607 57.6847 75.4265 59.1062C77.8924 60.5277 79.8941 58.9322 79.8941 55.567C79.8941 52.2018 77.8924 48.3145 75.4265 46.893C72.9607 45.5005 70.959 47.067 70.959 50.4322Z",
    fill: "#A6EE68"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.4698 89.6247L29.5605 62.5583V86.9848L76.4698 114.051V89.6247Z",
    fill: "url(#paint7_linear_1300_10058)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.5724 75.3518L57.6439 84.635V87.565L41.5724 78.2818V75.3518Z",
    fill: "#6F00FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41.5724 81.241L71.6268 98.589V101.548L41.5724 84.2V81.241Z",
    fill: "#6F00FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1074 76.2222C39.1074 78.2239 37.918 79.1813 36.4385 78.34C34.9589 77.4987 33.7695 75.1779 33.7695 73.1472C33.7695 71.1455 34.9589 70.1882 36.4385 71.0294C37.889 71.8997 39.1074 74.2205 39.1074 76.2222Z",
    fill: "#A6EE68"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.777 81.9753L168.867 54.9089V79.3354L215.777 106.431V81.9753Z",
    fill: "url(#paint8_linear_1300_10058)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M180.879 67.7312L196.95 77.0144V79.9444L180.879 70.6612V67.7312Z",
    fill: "#6F00FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M180.906 73.6204L210.961 90.9684V93.9274L180.906 76.5794V73.6204Z",
    fill: "#6F00FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.412 68.6016C178.412 70.6033 177.223 71.5607 175.743 70.7194C174.264 69.8781 173.074 67.5573 173.074 65.5266C173.074 63.5249 174.264 62.5675 175.743 63.4088C177.223 64.2791 178.412 66.5999 178.412 68.6016Z",
    fill: "#E4FBCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1300_10058",
    x1: 158.975,
    y1: 12.901,
    x2: 68.7965,
    y2: 169.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1300_10058",
    x1: 169.532,
    y1: 4.98349,
    x2: 79.3535,
    y2: 161.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1300_10058",
    x1: 142.157,
    y1: 46.969,
    x2: 72.5438,
    y2: 172.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1300_10058",
    x1: 135.608,
    y1: 198.505,
    x2: 96.6579,
    y2: 265.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1300_10058",
    x1: 208.618,
    y1: 118.711,
    x2: 155.921,
    y2: 210.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1300_10058",
    x1: 201.503,
    y1: 124.912,
    x2: 148.807,
    y2: 216.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1300_10058",
    x1: 69.7893,
    y1: 29.5452,
    x2: 29.2384,
    y2: 61.2953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1300_10058",
    x1: 58.3006,
    y1: 79.1308,
    x2: 47.7219,
    y2: 97.4585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1300_10058",
    x1: 197.625,
    y1: 71.5038,
    x2: 187.047,
    y2: 89.8314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.8cd497e95f6e0af2cb8404a055152911.svg";
export { ForwardRef as ReactComponent };